import { useEffect, useState } from "react";
import { getAllDocuments } from ".";
import LoggedInNavbar from "./loggedInNavbar";
import Header from "../../User/helper/Header";
import { isAuthenticated } from "../../Auth/helper";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import LoginPrompt from "../../components/LoginPrompt"; 

const ShowDocument = (props) => {
  const [prdtdt, setprdt] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false); // NEW
  let nav = useNavigate();

  useEffect(() => {
    const auth = isAuthenticated();

    // Not logged in — show login prompt instead of crashing
    if (!auth || !auth.user?._id || !auth.token) {
      setLoading(false);
      setShowPrompt(true);
      return;
    }

    setLoading(true);
    setError(null);

    getAllDocuments(auth.user._id, auth.token)
      .then((data) => {
        if (Array.isArray(data)) {
          setprdt(data);
        } else {
          setprdt([]);
          setError("Invalid data format received.");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching documents:", err);
        setprdt([]);
        setError("Failed to fetch documents. Please try again.");
        setLoading(false);
      });
  }, []);

  const handleDocumentClick = (id) => {
    const auth = isAuthenticated();
    if (!auth || !auth.user?._id) {
      setShowPrompt(true);
      return;
    }
    nav(`/displaydocument?id=${id}`);
  };

  const isLoggedIn = isAuthenticated() && isAuthenticated().user?._id && isAuthenticated().token;

  return (
    <>
      {/* Login Prompt Modal */}
      <LoginPrompt show={showPrompt} onClose={() => setShowPrompt(false)} />

      {/* Show correct navbar */}
      {isLoggedIn ? <LoggedInNavbar /> : <Header />}

      <div className="container">
        <br />
        <h2 style={{ color: "#E34607", lineHeight: "34px", padding: "20px" }}>
          Documents
        </h2>

        <div className="container">

          {/* Loading state */}
          {loading && (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }}>
              <CircularProgress color="warning" />
            </div>
          )}

          {/* Error state */}
          {!loading && error && (
            <div className="alert alert-danger" role="alert" style={{ borderRadius: 10 }}>
              <strong>Oops!</strong> {error}
            </div>
          )}

          {/* Empty state */}
          {!loading && !error && prdtdt.length === 0 && isLoggedIn && (
            <div style={{ textAlign: "center", padding: "60px 20px", color: "#888" }}>
              <i className="fas fa-file-alt" style={{ fontSize: 40, color: "#E34607", marginBottom: 16 }}></i>
              <p style={{ fontSize: 16 }}>No documents available at the moment.</p>
            </div>
          )}

          {/* Documents grid */}
          {!loading && !error && prdtdt.length > 0 && (
            <div className="row category-subcategory-container">
              {prdtdt.map((item, index) => (
                <div key={index} className="col-sm-3" style={{ marginBottom: "18px" }}>
                  <div
                    className="card"
                    style={{
                      width: "18rem", cursor: "pointer",
                      padding: "0px", border: "1px solid rgba(136,136,136,0.5)",
                      transition: "box-shadow 0.2s",
                    }}
                    onClick={() => handleDocumentClick(item.productPathCDN)}
                    onMouseEnter={(e) => e.currentTarget.style.boxShadow = "0 4px 16px rgba(227,70,7,0.15)"}
                    onMouseLeave={(e) => e.currentTarget.style.boxShadow = "none"}
                  >
                    <div className="card-body">
                      <img
                        src={item.thumbNailPathCDN}
                        height="200" width="200"
                        style={{ marginBottom: "10px" }}
                        alt={item.productName}
                      />
                      <br />
                      <center>
                        <h5 className="card-title" style={{ color: "#E34607" }}>
                          {item.productName}
                        </h5>
                      </center>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </div>
    </>
  );
};

export default ShowDocument;